"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultWidth = exports.defaultHeight = exports.zIndex = exports.iconSize = exports.iconColor = exports.errorColor = exports.alertColor = exports.generalColor = exports.dialogType = exports.classes = void 0;
var classes = {
  overlayContainer: 'overlay-container',
  dialogContainer: 'dialog-container',
  popupStrap: 'popup-strap',
  headingContainer: 'heading-container',
  titleContainer: 'title-container',
  iconContainer: 'icon-container',
  messageContainer: 'message-container',
  buttonContainer: 'button-container',
  buttonWrapper: 'button-wrapper',
  dialogChildrenWrapper: 'dialog-children-wrapper'
};
exports.classes = classes;
var dialogType = {
  general: 'general',
  alert: 'alert',
  error: 'error'
};
exports.dialogType = dialogType;
var generalColor = '#067FDB';
exports.generalColor = generalColor;
var alertColor = '#F1C21B';
exports.alertColor = alertColor;
var errorColor = '#E15C5C';
exports.errorColor = errorColor;
var iconColor = '#393939';
exports.iconColor = iconColor;
var iconSize = 24;
exports.iconSize = iconSize;
var zIndex = 200;
exports.zIndex = zIndex;
var defaultHeight = 278;
exports.defaultHeight = defaultHeight;
var defaultWidth = 464;
exports.defaultWidth = defaultWidth;